import { Component, inject } from '@angular/core';
import { ModalRef, ModalModule, ButtonV2Module } from '@schenck/rotec-components';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'rm-rollerbed-info-modal',
  templateUrl: './rollerbed-info-modal.component.html',
  styleUrls: ['./rollerbed-info-modal.component.less'],
  imports: [ModalModule, ButtonV2Module, TranslateDirective],
})
export class RollerbedInfoModalComponent {
  private readonly modalRef = inject(ModalRef);

  public summary = 'Pedestal Positions';

  public close(): void {
    this.modalRef.close();
  }
}
